import React from "react";

const InvestContent = () => {
  return (
    <div className="my-16 mx-16 py-10 rounded-2xl text-center border">
      <div>
        <h3 className="mb-8 text-themeColor">Can you invest in Thailand</h3>
      </div>
      <div
        className="my-20 text-medium font-medium"
        style={{ paddingLeft: "30px", paddingRight: "30px" }}
      >
        <p className="my-8">
          Explore the potential of investing in Thailand's booming real estate
          market. From luxurious beachfront properties to affordable city
          apartments, there is a wide range of opportunities available to suit
          any budget. With a stable economy and a growing tourism industry,
          property values in Thailand are on the rise. Whether you're looking
          for a long-term investment or a vacation home, investing in Thailand's
          real estate market can provide great returns. Our team of experts can
          help you navigate the process of purchasing property and assist you in
          finding the perfect investment opportunity. Contact us today to learn
          more about investing in Thailand's real estate market.
        </p>
      </div>
    </div>
  );
};

export default InvestContent;
